/* RESPONSIBLE TEAM: team-pricing-and-packaging */
// These are strings because Ember Data forces you to use strings for IDs

// pnp-addproduct
// This is where we declare constants associated with products in the system.
// This file is bundled into an npm package and used throughout our systems. When we make changes here, we must bump the npm package version.
export const INBOX_ID = '1';
export const MESSAGES_ID = '2';
export const LEARN_ID = '3'; // Dead
export const ACQUIRE_ID = '4'; // Dead
export const ARTICLES_ID = '5';
export const BUSINESS_PACKAGE_ID = '6';
export const OPERATOR_ID = '7';
export const ANSWER_BOT_ID = '8';
export const PRODUCT_TOURS_ID = '9';
export const CORE_ID = '10';
export const SALES_AUTOMATION_ID = '11';
export const SUPPORT_AUTOMATION_ID = '12';
export const PROACTIVE_MESSAGING_ID = '13';
export const NEGATIVE_PRICE_DISCOUNT_ID = '14';
export const CORE_STARTER_ID = '15'; // Starter
export const CORE_SUPPORT_ID = '16'; // Support
export const CORE_ENGAGE_ID = '17'; // Engage
export const CORE_CONVERT_ID = '18'; // Convert
export const PROACTIVE_SUPPORT_ID = '19'; // VBP 2.x's Proactive Support
export const ADVANCED_WORKSPACE_MANAGEMENT_ID = '20'; // Advanced Workspace Management
export const CUSTOM_API_RATE_LIMIT_ID = '21'; // Enterprise API Rate Limit
export const PEOPLE_REACHED_ID = '22'; // People Reached
export const WHATSAPP_ID = '23';
export const PREMIER_ONBOARDING_ID = '24';
export const PREMIER_SUCCESS_ID = '25';
export const PREMIER_SUPPORT_ID = '26';
export const SURVEYS_ID = '27';
export const SWITCH_ID = '28';
export const SMS_ID = '29';
export const PRICING_5_X_CORE_ID = '30'; // Pricing 5.0 Core
export const PROACTIVE_SUPPORT_PLUS_ID = '31'; // Proactive Support Plus
export const PREMIER_ONBOARDING_3_TIERS_ID = '33';
export const FIN_AI_COPILOT_ID = '34';
export const PRO_SERVE_ID = '35';
export const FIN_FOR_PLATFORMS_CORE_ID = '36';
export const AI_INSIGHTS_ID = '37';

// Plans
export const INBOX_ESSENTIAL_ID = '1';
export const INBOX_PRO_ID = '2';
export const INBOX_PREMIUM_ID = '13';
export const MESSAGES_ESSENTIAL_ID = '3';
export const MESSAGES_PRO_ID = '4';
export const MESSAGES_PREMIUM_ID = '14';
export const LEARN_LITE_ID = '5'; // Dead
export const LEARN_STANDARD_ID = '6'; // Dead
export const ACQUIRE_LITE_ID = '7'; // Dead
export const ACQUIRE_STANDARD_ID = '8'; // Dead
export const ARTICLES_ESSENTIAL_ID = '9';
export const BUSINESS_PACKAGE_ESSENTIAL_ID = '10';
export const BUSINESS_PACKAGE_PRO_ID = '11';
export const OPERATOR_PRO_ID = '12';
export const ANSWER_BOT_ESSENTIAL_ID = '15';
export const PRODUCT_TOURS_ESSENTIAL_ID = '16';
export const ARTICLES_PRO_ID = '17';

export const CORE_START_ID = '18';
export const CORE_GROW_ID = '19';
export const CORE_ACCELERATE_ID = '20';
export const CORE_SCALE_ID = '21';
export const SALES_AUTOMATION_BASE_ID = '22';
export const SUPPORT_AUTOMATION_BASE_ID = '23';
export const PROACTIVE_MESSAGING_BASE_ID = '24'; // Advanced Customer Engagement

export const NEGATIVE_PRICE_DISCOUNT_PLAN_ID = '25';

export const CORE_STARTER_BASE_ID = '26'; // Starter
export const CORE_SUPPORT_PRO_ID = '27'; // Support Pro
export const CORE_SUPPORT_PREMIUM_ID = '28'; // Support Premium
export const CORE_ENGAGE_PRO_ID = '29'; // Engage Pro
export const CORE_ENGAGE_PREMIUM_ID = '30'; // Engage Premium
export const CORE_CONVERT_PRO_ID = '31'; // Convert Pro
export const PROACTIVE_SUPPORT_BASE_ID = '32'; // Proactive Support
export const ADVANCED_WORKSPACE_MANAGEMENT_BASE_ID = '33'; // Advanced Workspace Management
export const CUSTOM_API_RATE_LIMIT_BASE_ID = '34'; // Enterprise API Rate Limit
export const PEOPLE_REACHED_TIER_1_ID = '35'; // People Reached - Tier 1
export const PEOPLE_REACHED_TIER_2_ID = '36'; // People Reached - Tier 2
export const PEOPLE_REACHED_TIER_3_ID = '37'; // People Reached - Tier 3
export const WHATSAPP_BASE_ID = '38';
export const PREMIER_ONBOARDING_BASE_ID = '39';
export const PREMIER_ONBOARDING_PLUS_ID = '40';
export const PREMIER_SUCCESS_BASE_ID = '41';
export const PREMIER_SUPPORT_TIER_1_ID = '42'; // Premier Support Tier 1
export const PREMIER_SUPPORT_TIER_2_ID = '43'; // Premier Support Tier 2
export const PREMIER_SUPPORT_TIER_3_ID = '44'; // Premier Support Tier 3
export const PREMIER_SUPPORT_TIER_4_ID = '45'; // Premier Support Tier 4
export const PREMIER_SUPPORT_RAPID_RESPONSE_TIER_1_ID = '46'; // Premier Support Rapid Response Tier 1
export const PREMIER_SUPPORT_RAPID_RESPONSE_TIER_2_ID = '47'; // Premier Support Rapid Response Tier 2
export const PREMIER_SUPPORT_RAPID_RESPONSE_TIER_3_ID = '48'; // Premier Support Rapid Response Tier 3
export const PREMIER_SUPPORT_RAPID_RESPONSE_TIER_4_ID = '49'; // Premier Support Rapid Response Tier 4
export const SURVEYS_BASE_ID = '50';
export const SWITCH_BASE_ID = '51';
export const SMS_BASE_ID = '52';
export const PRICING_5_X_CORE_ESSENTIAL_ID = '53'; // Pricing 5.0 Core - Essential (Tier 1)
export const PRICING_5_X_CORE_ADVANCED_ID = '54'; // Pricing 5.0 Core - Advanced (Tier 2)
export const PRICING_5_X_CORE_EXPERT_ID = '55'; // Pricing 5.0 Core - Expert (Tier 3)
export const PROACTIVE_SUPPORT_PLUS_BASE_ID = '56'; // Proactive Support Plus
export const PREMIER_ONBOARDING_3_TIERS_1_MONTH_ID = '58'; // Premier Onboarding 3 tiers variation active for 1 month
export const PREMIER_ONBOARDING_3_TIERS_2_MONTHS_ID = '59'; // Premier Onboarding 3 tiers variation active for 2 months
export const PREMIER_ONBOARDING_3_TIERS_3_MONTHS_ID = '60'; // Premier Onboarding 3 tiers variation active for 3 months
export const FIN_AI_COPILOT_BASE_ID = '61';
export const PRO_SERVE_BASE_ID = '63';
export const FIN_FOR_PLATFORMS_BASE_ID = '64';
export const AI_INSIGHTS_BASE_ID = '65';
